export default "__VITE_ASSET__McDAJ9qh__"